import $ from 'jquery';

const Footer = {
  init: function () {
    this.newsletterForm();
    this.formValidation();
  },

  newsletterForm: function () {
    const form = document.getElementById('subscribe-form');
    const emailInput = form?.querySelector(".inf-input-text input[type='email']")

    if (emailInput) {
      emailInput.onfocus = function() {
        form.classList.add('focused');
      };

      emailInput.onblur = function() {
        form.classList.remove('focused');
      };

      emailInput.onmouseenter = function() {
        form.classList.add('hovered');
      };

      emailInput.onmouseleave = function() {
        form.classList.remove('hovered');
      };
    }
  },

  formValidation: function () {
    const form = $('#contact-form');

    form.on("submit", function(event) {
      event.preventDefault();
      let isValid = true;

      const FirstNameInput = $(this).find("#contact-inf-2");
      const LastNameInput = $(this).find("#contact-inf-3");
      const emailInput = $(this).find("#contact-inf-1");
      const phoneInput = $(this).find("#contact-inf-4");
      const message = $(this).find("#contact-inf-5").val().trim();

      const first = FirstNameInput.val().trim();
      const last = LastNameInput.val().trim();
      const email = emailInput.val().trim();
      const phone = phoneInput.val().trim();

      if (first === "") {
        FirstNameInput.closest('.inf-input').addClass("error");
        isValid = false;
      } else {
        FirstNameInput.closest('.inf-input').removeClass("error");
      }

      if (last === "") {
        LastNameInput.closest('.inf-input').addClass("error");
        isValid = false;
      } else {
        LastNameInput.closest('.inf-input').removeClass("error");
      }

      if (email === "" || !validateEmail(email)) {
        emailInput.closest('.inf-input').addClass("error");
        isValid = false;
      } else {
        emailInput.closest('.inf-input').removeClass("error");
      }

      if (phone === "") {
        phoneInput.closest('.inf-input').addClass("error");
        isValid = false;
      } else {
        phoneInput.closest('.inf-input').removeClass("error");
      }

      if (!isValid) {
        return
      }

      let formData = new FormData(this);

      formData.append('action', 'submit_form');

      if (first) {
        formData.append('first_name', first);
      }

      if (last) {
        formData.append('last_name', last);
      }

      if (email) {
        formData.append('email', email);
      }

      if (phone) {
        formData.append('phone', phone);
      }

      if (message) {
        formData.append('message', message);
      }

      console.log(formData)

      $.ajax({
        url: themeVars.ajax_url,
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        success: function() {
          $('.contact-form-inf-success').show();
          form.hide();
        },
        error: function(jqXHR, textStatus, errorThrown) {
          console.log(textStatus, errorThrown);
        },
      });
    });

    function validateEmail(email) {
      const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      return re.test(String(email).toLowerCase());
    }
  },
};

export default Footer;
